<template>
  <aside
    class="flex h-full w-[260px] shrink-0 flex-col gap-1 border-r border-border bg-muted/30 p-4"
  >
    <h2 class="px-2 pb-4 text-xl font-semibold text-foreground">
      {{ $t("notifications.title") }}
    </h2>

    <NavList
      :items="navItems"
      :active-key="activeKey"
      :aria-label="$t('notifications.title')"
      @select="(key) => $emit('select', key)"
    />

    <div
      v-if="loadingCategories && categories.length === 0"
      class="flex flex-col gap-1"
    >
      <div
        v-for="i in 5"
        :key="i"
        class="h-9 animate-pulse rounded-md bg-muted/60"
      />
    </div>
  </aside>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { NavList } from "@/shared/ui/nav-list";
import {
  svgIconForCategory,
  variantForCategory,
} from "@/entities/notification";

const props = defineProps({
  activeKey: { type: String, default: "all" },
  categories: { type: Array, default: () => [] },
  totalUnread: { type: Number, default: 0 },
  loadingCategories: { type: Boolean, default: false },
});

defineEmits(["select"]);

const { t } = useI18n();

const navItems = computed(() => {
  const items = [
    {
      key: "all",
      label: t("notifications.tabs.all"),
      icon: "sli-empty-bookmark",
      iconVariant: "default",
      count: props.totalUnread,
    },
  ];

  for (const cat of props.categories) {
    items.push({
      key: cat.key,
      label: cat.title,
      icon: svgIconForCategory(cat.key, cat.title),
      iconVariant: variantForCategory(cat.key, cat.title),
      count: cat.count,
    });
  }

  return items;
});
</script>
